export default __webpack_public_path__ + "static/media/3.182fd085.jpeg";